import React from "react";
import { useNavigate, useOutletContext } from "react-router-dom";

export const btnPrimary =
  "inline-flex items-center justify-center px-6 py-3 rounded-md bg-teal-700 hover:bg-teal-800 text-white font-bold text-sm transition-colors disabled:opacity-50";
export const btnOutlineDark =
  "inline-flex items-center justify-center px-6 py-3 rounded-md border border-white/40 hover:bg-white/10 text-white font-semibold text-sm transition-colors";
export const btnOutlineLight =
  "inline-flex items-center justify-center px-6 py-3 rounded-md border border-teal-400 text-teal-800 hover:bg-teal-100 font-semibold text-sm transition-colors";

export const cardClass = "bg-teal-50 border border-teal-200 rounded-xl p-6";
export const cardTitleClass = "text-lg font-extrabold text-teal-900";
export const cardIconClass = "w-11 h-11 shrink-0 rounded-lg bg-teal-700 text-white flex items-center justify-center";
export const fieldClass =
  "w-full rounded-md border border-teal-300 bg-white px-4 py-3 text-sm outline-none focus:border-teal-600 focus:ring-2 focus:ring-teal-600/10";

/** Opens the shared sign-in / sign-up popup from WebLayout; falls back to the auth pages. */
export const useAuthActions = () => {
  const navigate = useNavigate();
  const context = useOutletContext() || {};
  return {
    openSignup: context.openSignup || (() => navigate("/signup")),
    openLogin: context.openLogin || (() => navigate("/login")),
  };
};

export const PageHero = ({ eyebrow, title, description, children }) => (
  <section className="bg-teal-900 text-white">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 py-16 md:py-20 text-center">
      {eyebrow ? (
        <p className="hero-in hero-in-1 text-xs font-bold uppercase tracking-[0.16em] text-teal-300 mb-3">{eyebrow}</p>
      ) : null}
      <h1 className="hero-in hero-in-2 text-3xl md:text-5xl font-extrabold text-balance">{title}</h1>
      {description ? (
        <p className="hero-in hero-in-3 text-teal-100 mt-4 max-w-2xl mx-auto">{description}</p>
      ) : null}
      {children ? <div className="hero-in hero-in-4">{children}</div> : null}
    </div>
  </section>
);

export const Section = ({ tone = "base", width = "max-w-7xl", className = "", children }) => (
  <section
    className={`py-14 md:py-20 px-4 sm:px-6 ${tone === "alt" ? "bg-teal-100 border-y border-teal-200" : ""} ${className}`}
  >
    <div className={`${width} mx-auto`}>{children}</div>
  </section>
);

export const SectionHeading = ({ eyebrow, title, description, align = "center" }) => (
  <div className={`mb-8 md:mb-10 ${align === "center" ? "text-center max-w-2xl mx-auto" : ""}`}>
    {eyebrow ? (
      <p className="text-xs font-bold uppercase tracking-[0.16em] text-teal-700 mb-3">{eyebrow}</p>
    ) : null}
    <h2 className="text-2xl md:text-3xl font-extrabold text-teal-900">{title}</h2>
    {description ? <p className="text-teal-800 mt-3 leading-relaxed">{description}</p> : null}
  </div>
);

export const CtaSection = ({ title, description, children }) => (
  <section className="py-14 md:py-20 px-4 sm:px-6 bg-teal-900 text-white">
    <div className="max-w-4xl mx-auto text-center reveal">
      <h2 className="text-2xl md:text-4xl font-extrabold text-balance">{title}</h2>
      {description ? <p className="text-teal-100 mt-4 text-base md:text-lg">{description}</p> : null}
      <div className="mt-7 flex flex-col sm:flex-row justify-center gap-3">{children}</div>
    </div>
  </section>
);
